import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { Route, Routes } from "react-router-dom";
import { Routes as RoutesComponent } from "./routes";
export const RouterManager = () => {
    const routes = useMemo(() => Object.keys(RoutesComponent).map((path) => {
        const RouteComponent = RoutesComponent[path];
        return _jsx(Route, { path: path, element: _jsx(RouteComponent, {}) }, path);
    }), []);
    return _jsx(Routes, { children: routes });
};
